<div class="www-agreements">
  <div class="www-agreements__con">
    <p class="www-agreements__con__des">
      Wyrażam zgodę na kontakt przez L’Oréal Polska Sp. z o.o. z<br class="d-none d-md-inline" />
      siedzibą w Warszawie (00-844 przy ul. Grzybowskiej 62) w celu<br class="d-none d-md-inline" />
      marketingu bezpośredniego, w tym przesyłania informacji<br class="d-none d-md-inline" />
      handlowych, w szczególności przesyłania informacji handlowych<br class="d-none d-md-inline" />
      dotyczących produktów marek (L’Oréal Professionnel, Kérastase,<br class="d-none d-md-inline" />
      Matrix, Biolage, Redken) za pośrednictwem następujących<br class="d-none d-md-inline" />
      kanałów komunikacji:
    </p>

    <form
      [formGroup]="formGroup"
      [ngxsFormClearOnDestroy]="_isBrowser"
      [ngxsFormDebounce]="20"
      [ngxsForm]="'myData.form'"
      class="www-form www-agreements__form"
      appInvalidControlScroll
      [appAnimate]="'fadeInLeft'"
      [speed]="'fast'"
    >
      <div class="row">
        <div class="col-12 mb-2">
          <div>
            <input type="checkbox" id="regulation" [formControlName]="'agreement'" />
            <label for="regulation">
              Akceptacja
              <a href="/assets/files/Regulamin PRO.CONNECT_2025.pdf" target="_blank">regulaminu L'Oréal PRO.CONNECT</a
              >.</label
            >
          </div>
        </div>

        <div class="col-12">
          <div>
            <input type="checkbox" id="agreementEmail" [formControlName]="'agreementEmail'" />
            <label for="agreementEmail">E-mail</label>
          </div>
          <app-validate-message [control]="f.agreementEmail" />
        </div>

        <div class="col-12">
          <div>
            <input type="checkbox" id="agreementSms" [formControlName]="'agreementSms'" />
            <label for="agreementSms">SMS</label>
          </div>
          <app-validate-message [control]="f.agreementSms" />
        </div>
        <div class="col-12">
          <div>
            <input type="checkbox" id="agreementPhone" [formControlName]="'agreementPhone'" />
            <label for="agreementPhone">Połączenie telefoniczne</label>
          </div>
          <app-validate-message [control]="f.agreementPhone" />
        </div>
        <div class="col-12 mb-3">
          <div>
            <input type="checkbox" id="agreementWhatsApp" [formControlName]="'agreementWhatsApp'" />
            <label for="agreementWhatsApp">Whatsapp</label>
          </div>
          <app-validate-message [control]="f.agreementWhatsApp" />
        </div>
      </div>
    </form>

    <p class="www-agreements__con__des">
      <span
        >Administratorem Pani/Pana danych osobowych jest L’Oréal Polska<br class="d-none d-md-inline" />
        Sp. z o.o., z siedzibą w Warszawie (00-844) przy ul. Grzybowska<br class="d-none d-md-inline" />
        62.
        <a [ngClass]="{ 'd-none': extendedRules() }" (click)="extendedRules.set(!extendedRules())">{{
          extendedRules() ? ' « mniej' : ' więcej »'
        }}</a>
      </span>
      <span class="hide" [ngClass]="{ show: extendedRules() }">
        Lorem Ipsum is simply dummy text of the printing and typesetting<br class="d-none d-md-inline" />
        industry. Lorem Ipsum has been the industry's standard dummy text ever<br class="d-none d-md-inline" />
        since the 1500s, when an unknown printer took a galley of type and<br class="d-none d-md-inline" />
        scrambled it to make a type specimen book. It has survived not only<br class="d-none d-md-inline" />
        five centuries, but also the leap into electronic typesetting,<br class="d-none d-md-inline" />
        remaining essentially unchanged. It was popularised in the 1960s<br class="d-none d-md-inline" />
        with the release of Letraset sheets containing Lorem Ipsum passages,<br class="d-none d-md-inline" />
        and more recently with desktop publishing software like Aldus PageMaker<br class="d-none d-md-inline" />
        including versions of Lorem Ipsum
        <a [ngClass]="{ 'd-none': !extendedRules() }" (click)="extendedRules.set(!extendedRules())">{{
          extendedRules() ? ' « mniej' : ' więcej »'
        }}</a>
      </span>
    </p>
  </div>
</div>
